export const UNAUTHORIZED_MESSAGES: Record<string, string> = {
  CHANGEPASSWORD:
    "アカウント情報が変更されたため、この操作は実行できません。再度ログインしてください。",
  UNVERIFIED:
    "アカウントが存在しない、または削除されています。再度ログインしてください。",
  DEFAULT:
    "アカウントが存在しない、または削除されています。再度ログインしてください。",
};
